import React from "react";
import DestaqueSecundario from "../../../NoticiaCard/Destaque/Secundario";

import { Container, Sessao, Wrapper } from "./styles";

function SubDestaque(props) {
  const noticias = props.noticias;

  return (
    <Sessao>
      <Container>
        <Wrapper>
          {noticias.map((noticia) => {
            return (
              <>
                <DestaqueSecundario
                  categorias={noticia.categorias}
                  img={noticia.noticia_img_path}
                  previa={noticia.previa_texto}
                  titulo={noticia.titulo}
                  to={`noticias/${noticia.id}`}
                  data={noticia.data_de_publicacao}
                />
              </>
            );
          })}
        </Wrapper>
      </Container>
    </Sessao>
  );
}

export default SubDestaque;
